import { useQuery } from 'react-query';
import { TypeTherapist, TypeTherapistFields } from 'types/contentful/marketing';
import ContentService from 'utils/contentful/contentfulService';

export const useContentfulTherapist = (therapistName: string) => {
  return useQuery(['contentful-therapist', therapistName], async () => {
    const data = await ContentService.clients.marketing.getEntries<TypeTherapistFields>({
      content_type: 'therapist',
      'fields.name[match]': therapistName,
    });

    return data.items[0] as TypeTherapist | undefined;
  });
};
